import { ChevronDown } from 'lucide-react'
import { useNavigate } from 'react-router'
import Logo2 from '../assets/checker/logo2.svg';
import { ServicesNavButton } from '@podus/ui';

export default function Header() {
  const navigate = useNavigate()

  return (
    <header className='bg-white px-4 md:px-8 lg:px-12 py-3 md:py-4 flex items-center justify-between shadow-sm sticky top-0 z-50'>
      {/* Left Navigation */}
      <nav className='hidden lg:flex items-center gap-6 xl:gap-10'>
        <a href='/' className='text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600'>
          Home
        </a>
        <a href='/about' className='text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600'>
          About
        </a>
        <ServicesNavButton
          style={{ fontSize: 14, fontWeight: 400, color: '#111827' }}
          className='text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600'
        />
        <a href='/blogs' className='text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600'>
          Blogs
        </a>
      </nav>

      {/* Mobile Menu Button */}
      <button className='lg:hidden text-gray-900'>
        <svg className='w-6 h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 6h16M4 12h16M4 18h16' />
        </svg>
      </button>

      {/* Center Logo */}
      <div className='absolute left-1/2 transform -translate-x-1/2 flex items-center gap-2'>
        <img src={Logo2} alt="Podus Checker Logo" className='' />
      </div>

      {/* Right Navigation */}
      <div className='hidden md:flex items-center gap-3 lg:gap-6'>
        <a href='/help' className='hidden lg:block text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600'>
          Help
        </a>
        <button className='hidden lg:flex text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600 items-center gap-1'>
          EN
          <ChevronDown className='w-4 h-4' />
        </button>
        <button onClick={() => navigate('/signup')} className='hidden lg:block text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600'>
          Sign Up
        </button>
        <button onClick={() => navigate('/login')} className='bg-black text-white px-4 md:px-5 lg:px-7 py-2 md:py-2.5 rounded-full text-[13px] md:text-[15px] font-medium hover:bg-gray-900 transition-colors'>
          Login
        </button>
      </div>

      {/* Mobile Login Button */}
      <button onClick={() => navigate('/login')} className='md:hidden bg-black text-white px-4 py-2 rounded-full text-[13px] font-medium'>
        Login
      </button>
    </header>
  )
}
